<template>
    <div>

        <v-container grid-list-xs>
              <template>
                  <v-toolbar flat color="white">
                        
                        <v-toolbar-title>
                            <v-text-field @click="show_dialog()"
                                v-model="date"  
                                label="Log Date"
                                required
                            ></v-text-field>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-title>
                            <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Search"
                            ></v-text-field>
                        </v-toolbar-title>                      
                  </v-toolbar>
              </template>
          </v-container>

            <v-dialog v-model="dialog" max-width="290">
                <v-card>
                    <v-date-picker v-model="date"></v-date-picker>
                    <v-spacer></v-spacer>
                        <v-btn block  @click="hide_dialog()" color="primary">Select</v-btn>
                        <v-btn block @click="hide_clear_dialog()" >Clear</v-btn>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialog_l" max-width="290">
                <v-card>
                    <v-card-title class="headline">Log</v-card-title>
                        <v-container grid-list-xs>
                              <p>Code : {{current_cust_code}}</p>
                              <p>Name : {{current_cust_name}}</p>  
                               
                        </v-container>      

                </v-card>
            </v-dialog>

        <v-container grid-list-xs>
            <v-data-table
                class="table"
                :headers="headers"
                :items="users"
                :search="search"
                :rows-per-page-items="[10, 25]">
                <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.code }}</td>
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-left">{{ props.item.email }}</td>
                <td class="text-xs-left">{{ props.item.tel }}</td>
                <td class="text-xs-center">
                    <v-icon class="mr-2" @click="view_log(props.item.code)">view_list</v-icon>
                </td>

                </template>

            </v-data-table>

        </v-container>

    </div>
</template>

<script>
import axios from "axios"
export default {

data() {
    return {
            /** กำหนด headers ให้ตรง */
            headers:[ 
              { text: 'Code', value: 'code' },
              { text: 'Name', value: 'name' },
              { text: 'Email', value: 'email' },
              { text: 'Tel', value: 'tel' },
              { text: 'Actions', value: 'actions', align: 'center', sortable: false },
            ],
            table_details:[],
            users: [],
            search: '',
            current_cust_code : '',
            current_cust_name : '',
            url : "https://ws.plantifulbkk.shop/images/" ,
            date: new Date().toISOString().substr(0, 10),
            dialog : false,
            dialog_l : false,
        }
    },
    created () {
      console.log("CREATE")
      this.read_data()
    },

    methods :{

        show_dialog(){
            this.dialog = true
            this.users = []
        },
        hide_dialog(){
            this.read_data()
            this.dialog = false
        },
        hide_clear_dialog(){
            var date_clear = new Date().toISOString().substr(0, 10)
            this.date = date_clear
            this.dialog = false
        },

        read_data() {
            const vm = this;

            vm.axios.get("https://ws.plantifulbkk.shop/get_even_log_cust_code.php",{
                params: {
                    sdate: this.date ,
                }
            }).then(result=>{
                var result = JSON.parse(JSON.stringify(result.data))
                vm.users = result
                console.log(vm.users)
                })
            .catch(function (error) {
                    console.log(error)
                })

        },

        view_log(item, name){
            this.$store.dispatch('set_user_ac_code', item  )
            this.$store.dispatch('set_user_ac_name', name )
            this.$store.dispatch('set_date_ac', this.date )
            this.$router.push('/customer_log_details')
        },
       
    },
    

}


</script>

<style>
 
@import url('https://fonts.googleapis.com/css2?family=Mitr:wght@200&display=swap');

H2 {
  font-family: 'Mitr', sans-serif;
}

</style>


// WEBPACK FOOTER //
// src/pages/customer_log.vue